import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-6',
  pageRule: [
    {
      logic: 'eval',
      targets: ['nextPage'],
      property: 'isMarried',
      operator: 'equal',
      triggerValue: 'true',
      resultValue: 'page-5.2'
    }
  ],
  content: [
    configureProgressBar(19),
    configureTitle('Are you married?'),
    {
      component: ButtonGroup,
      name: 'isMarried',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'isMarried',
        options: [
          {
            displayValue: 'Yes',
            id: 'isMarriedYes',
            value: 'true'
          },
          {
            displayValue: 'No',
            id: 'isMarriedNo',
            value: 'false'
          }
        ]
      }
    },
    nextButtonConfig('page-5.1')
  ]
};
